const resource = "categories";

export default ($axios, isAdmin = false) => ({
	// GET
	getCategories(params={}) {
		return $axios.get(`${isAdmin?'/superAdmin':''}/${resource}`, { params } )
	},
});
